import { useEffect } from 'react';
import { isIncomingEvent } from '../postMessage';

// Opt-in, not on by default: hosts that never asked keep receiving exactly
// the events they integrated against.
let isHostListening = false;

export function isHostListeningForHaptics(): boolean {
  return isHostListening;
}

/**
 * Parent → iframe `{ source: 'repackz-parent', type: 'enable_haptics' }`.
 * From then on every haptic beat is also posted to the host as `haptic`.
 */
export function useEnableHapticsListener(): void {
  useEffect(() => {
    function onMessage(e: MessageEvent) {
      if (!isIncomingEvent(e.data) || e.data.type !== 'enable_haptics') return;
      isHostListening = true;
    }
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);
}
